import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getWarehouses } from "../../store/AsyncMethods/WarehouseMethod";
import WarehousesTable from "./WarehousesTable";

export default function WarehousesMain() {
  const dispatch = useDispatch();
  const { user } = useSelector((state) => state.AuthReducer);

  useEffect(() => {
    if (user) {
      dispatch(getWarehouses());
    }
  }, [dispatch, user]);

  return (
    <div className="mx-3">
      <div className="my-4">
        <WarehousesTable />
      </div>
    </div>
  );
}
